module.exports = __webpack_public_path__ + "img/icons-fill-team-sapphire.c9519e10.svg";